import { RouteObject } from 'react-router-dom'
import PoliticasSimulacaoPage from '@/pages/simulacao/PoliticasSimulacaoPage'

/**
 * Rotas do DEV-5 (plano Pipeline/Simulações, Rodada 2) — políticas de simulação (ADMIN).
 *
 * `/simulacoes` (consultor) continua em `rotas/a15.tsx`; `/simulacoes/politicas` é uma
 * rota irmã, mais específica, que o roteador prefere ao `PorAba` de `/simulacoes`.
 * O gate é o papel (ADMIN no backend e na página) — sem permissão a própria página mostra
 * o estado "sem permissão".
 */
const rotasPipeDev5: RouteObject[] = [
  { path: 'simulacoes/politicas', element: <PoliticasSimulacaoPage /> },
]

export default rotasPipeDev5
